import { request } from '@@/plugin-request';

export async function getContractById(id) {
  return request(`/api/contracts/lessonModal/${id}`, {
    method: 'GET',
  });
}

export async function getLessonCount(params) {
  return request(`/api/lessons/count`, {
    method: 'GET',
    params,
  });
}

export async function getById(id) {
  return request(`/api/lessons/${id}`, {
    method: 'GET',
  });
}

export async function getLessonByTeacher(params) {
  return request(`/api/lessons/teacher`, {
    method: 'GET',
    params,
  });
}

export async function checkConflictLesson(payload) {
  return request(`/api/lessons/checkConflictLesson`, {
    method: 'POST',
    data: payload,
  });
}

export async function checkTeacherLast3MonthLesson(payload) {
  return request(`/api/lessons/checkTeacherLast3MonthLesson`, {
    method: 'POST',
    data: payload,
  });
}

export async function sendMessageToRecruiter(payload) {
  return request(`/api/lark/sendMessageToRecruiter`, {
    method: 'POST',
    data: payload,
  });
}

export async function getGradingSchemeByCourse(params) {
  return request('/api/semester/gradingSchemeByCourse', {
    method: 'GET',
    params,
  });
}

export async function getAppealServiceProcess(params) {
  return request('/api/appealService/process', {
    method: 'GET',
    params,
  });
}
